export enum PaymentChannelType {
  TYPE_UNSET = 'TYPE_UNSET', // Do not use, needed because of proto3 limitations
  OXXO_PAY = 'OXXO_PAY',
  PHYSICAL_STORE = 'PHYSICAL_STORE',
  SUPPORT = 'SUPPORT',
  REWARD = 'REWARD',
  SELLER_REWARD = 'SELLER_REWARD',
  PRE_PROVISIONING = 'PRE_PROVISIONING',
  API_SALE = 'API_SALE',
  OPEN_PAY = 'OPEN_PAY',
  CREDIT_CARD = 'CREDIT_CARD',
  SELLER_APP = 'SELLER_APP',
  POINT_BANK = 'POINT_BANK',
  VESTA_CARD = 'VESTA_CARD',
  PORTAL = 'PORTAL',
}
